// Fuente unica de queryKeys de React Query para el modulo de tickets.
// Jerarquia pensada para invalidar por prefijo:
//   ['tickets','lista']            -> todas las listas
//   ['tickets','detalle',hq,id]    -> todo lo de un ticket (detalle, comentarios, ...)
export const ticketsKeys = {
  all: ['tickets'],
  usuarios: (hq) => ['tickets', 'usuarios', hq],
  estados: (hq) => ['tickets', 'estados', hq],
  grupos: (hq) => ['tickets', 'grupos', hq],
  temas: (hq) => ['tickets', 'temas', hq],
  etiquetas: (hq) => ['tickets', 'etiquetas', hq],
  lista: (hq, filtros) => ['tickets', 'lista', hq, filtros],
  detalle: (hq, id) => ['tickets', 'detalle', hq, id],
  comentarios: (hq, id, soloPublicos) => [
    'tickets',
    'detalle',
    hq,
    id,
    'comentarios',
    soloPublicos,
  ],
  adjuntos: (hq, id) => ['tickets', 'detalle', hq, id, 'adjuntos'],
  borrador: (hq, id) => ['tickets', 'detalle', hq, id, 'borrador'],
  historial: (hq, id) => ['tickets', 'detalle', hq, id, 'historial'],
  informeFiltros: (hq) => ['tickets', 'informe', 'filtros', hq],
  informeActividad: (hq, filtros) => ['tickets', 'informe', 'actividad', hq, filtros],
  respuestas: (hq) => ['tickets', 'respuestas', hq],
  bloqueos: (hq) => ['tickets', 'bloqueos', hq],
  descartados: (hq) => ['tickets', 'descartados', hq],
};

export default ticketsKeys;
